module.exports = __webpack_public_path__ + "static/graph-2386ce90a4a5b55a0b24840f9b62f70e.jpg";